import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { PwaUpdateService } from '../services/pwa-update.service';

/**
 * A 404/405 from the API usually means this (old) frontend is calling an endpoint the newly
 * deployed backend no longer has. Trigger a service worker update check right away instead of
 * waiting for the next poll; if a new build is available the PwaUpdateService reloads the page.
 */
@Injectable()
export class VersionCheckInterceptor implements HttpInterceptor {

  constructor(private pwaUpdateService: PwaUpdateService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        error: (error: unknown) => {
          if (error instanceof HttpErrorResponse && (error.status === 404 || error.status === 405)) {
            this.pwaUpdateService.checkForUpdate();
          }
        }
      })
    );
  }
}
